import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Jakarta Sans font is imported in index.html */

  :root {
    --primary-color: #FF6B00;
    --secondary-color: #333333;
    --background-color: #FFFFFF;
    --text-color: #333333;
    --light-gray: #F5F5F5;
    --border-color: #DDDDDD;
    --font-jakarta: 'Plus Jakarta Sans', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 100px; /* Adjust based on header height */
  }

  body {
    font-family: 'Inter', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text-color);
    background-color: var(--background-color);
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  p {
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  section {
    padding: 4rem 0;
    
    @media (max-width: 768px) {
      padding: 3rem 0;
    }
    
    @media (max-width: 480px) {
      padding: 2rem 0;
    }
  }
  
  .font--jakarta h1, .font--jakarta h2 {
    font-family: var(--font-jakarta);
    font-weight: 800;
  }
`;

export default GlobalStyles; 